import React from "react";
import Button from "@components/Button/Button.tsx";
import { useAuthStore } from "@persisted-state/auth/auth.store";
import { checkPermission } from "@utils/user-permissions";
import { useTranslation } from "react-i18next";

interface FlowActionButtonProps {
  langBase: string;
  permission?: string | string[];
  isActionAvailable: boolean;
  labelKey: string;
  testId: string;
  variant: React.ComponentProps<typeof Button>["variant"];
  startIcon?: React.ReactNode;
  onClick: () => void;
  type?: "button" | "submit" | "reset";
  className?: string;
}

const FlowActionButton: React.FC<FlowActionButtonProps> = ({
  langBase,
  permission,
  isActionAvailable,
  labelKey,
  testId,
  variant,
  startIcon,
  onClick,
  type = "button",
  className = "whitespace-nowrap",
}) => {
  const { userActionPermissions } = useAuthStore();
  const { t } = useTranslation();

  const hasPermission = permission
    ? Array.isArray(permission)
      ? permission.some((item) => checkPermission(userActionPermissions, item))
      : checkPermission(userActionPermissions, permission)
    : true;

  if (!hasPermission) {
    return null;
  }

  if (!isActionAvailable) {
    return null;
  }

  return (
    <Button
      testId={testId}
      variant={variant}
      type={type}
      startIcon={startIcon}
      className={className}
      onClick={onClick}
      label={<span className="normal-case font-medium">{t(`${langBase}.${labelKey}`)}</span>}
    />
  );
};

export default FlowActionButton;
